import { memo } from 'react';

import ZoomOutIconSVG from '@/assets/zoom-out-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IZoomOutIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={ZoomOutIconSVG} {...props} />;

export const ZoomOutIcon = memo(IZoomOutIcon) as typeof IZoomOutIcon;
